var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconSwapUpDown = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M5.78025 9.53025L7.5 7.8105V17.25C7.5 17.664 7.836 18 8.25 18C8.664 18 9 17.664 9 17.25V7.8105L10.7198 9.53025C11.0123 9.82275 11.4878 9.82275 11.7803 9.53025C12.0728 9.23775 12.0735 8.76225 11.7803 8.46975L8.78025 5.46975C8.48775 5.1765 8.01225 5.1765 7.71975 5.46975L4.71975 8.46975C4.4265 8.76225 4.4265 9.23775 4.71975 9.53025C5.013 9.82275 5.48775 9.82275 5.78025 9.53025ZM19.2803 14.4698C18.9878 14.1773 18.5123 14.1773 18.2198 14.4698L16.5 16.1895V6.75C16.5 6.336 16.164 6 15.75 6C15.336 6 15 6.336 15 6.75V16.1895L13.2803 14.4698C12.9878 14.1773 12.5123 14.1773 12.2198 14.4698C11.9273 14.7623 11.9273 15.2378 12.2198 15.5303L15.2198 18.5303C15.5123 18.8228 15.9878 18.8228 16.2803 18.5303L19.2803 15.5303C19.5728 15.2378 19.5728 14.7623 19.2803 14.4698Z", fill: "black" }))),
        alt: 'Icon SwapUpDown',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconSwapUpDown;
//# sourceMappingURL=index.js.map